 import {Component, Input, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'policy-studio-action-box',
  templateUrl: './policy-studio-action-box.component.html',
  styleUrls: ['./policy-studio-action-box.component.less']
})
export class PolicyStudioActionBoxComponent {

  @Input() item: any;

  constructor() {}

  isValueExists(value): boolean {
    return _.isArray(value) && value.length > 0;
  }

  getFormattedDidCountTimeOfDay(): string{
    let [hour, minute] = this.item.didCountTimeOfDay.split(':');
    hour = parseInt(hour, 10);
    minute = parseInt(minute, 10);
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (minute < 10) {
      minute = '0' + minute;
    }
    return hour + ':' + minute;
  }

}
